import './_styles.scss';
import './_styles.dark-mode.scss';
import React, { useCallback, useEffect, useMemo } from 'react';
import { Route, Switch, useRouteMatch, useLocation, useHistory, Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Row, Col, Nav, NavItem } from 'react-bootstrap';

import ReportsLoader from './components/Loader';
import PaymentsChart from './Payments/Chart';
import PaymentsTable from './Payments/Table';
import OrdersTable from './Orders';
import TicketsTable from './Tickets';
import ProfitsTable from './Profits';
import ReportsServices from './Services';
import PaymentsSelectRange from './Payments/Chart/components/Filters/SelectRange';
import PaymentsTableFilters from './Payments/Table/components/Filters';
import OrdersTableFilters from './Orders/components/Filters';
import TicketsTableFilters from './Tickets/components/Filters';
import ProfitsTableFilters from './Profits/components/Filters';
import ServicesTableFilters from './Services/components/Filters';

import { getReportsConfigAction } from '../../redux/actions/reports';

const routesComponents = {
  payments: [
    {
      code: 'payments-chart',
      component: PaymentsChart,
      to: '/reports/payments',
      exact: true,
    },
    {
      code: 'payments-table',
      component: PaymentsTable,
      to: '/reports/payments/table',
    },
  ],
  orders: [
    {
      code: 'orders',
      component: OrdersTable,
      to: '/reports/orders',
    },
  ],
  tickets: [
    {
      code: 'tickets',
      component: TicketsTable,
      to: '/reports/tickets',
    },
  ],
  profits: [
    {
      code: 'profits',
      component: ProfitsTable,
      to: '/reports/profits',
    },
  ],
  services: [
    {
      code: 'services',
      component: ReportsServices,
      to: '/reports/services',
    },
  ],
};

const Reports = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { url } = useRouteMatch();

  const reports = useSelector((state) => state.reports);
  const { isLoading, isLoadingPageConfig, mainConfig: config, pageConfig, pageFilters, pageFilterType } = reports;

  const routes = useMemo(
    () => config?.reports?.reduce((acc, item) => {
      const compRoutes = routesComponents[item.code];
      if (compRoutes) {
        return [...acc, ...compRoutes];
      }
      return acc;
    }, []),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [config, url],
  );

  const navRoutes = useMemo(() => {
    if (config?.reports) {
      return config.reports;
    }
    return [];
  }, [config.reports])

  const onSelectTab = (item) => {
    history.push(item.url.replace('/admin', ''));
  };

  const renderFilter = useCallback(() => {
    if (!pageFilterType && !isLoadingPageConfig) {
      return null;
    }
    switch (pageFilterType) {
    case 'payments-chart':
      return <PaymentsSelectRange currentFilters={pageFilters} filters={pageConfig?.filters} />;
    case 'payments-table':
      return <PaymentsTableFilters currentFilters={pageFilters} filters={pageConfig?.filters} />;
    case 'orders-table':
      return <OrdersTableFilters currentFilters={pageFilters} filters={pageConfig?.filters} />;
    case 'tickets-table':
      return <TicketsTableFilters currentFilters={pageFilters} filters={pageConfig?.filters} />;
    case 'services-table':
      return <ServicesTableFilters currentFilters={pageFilters} filters={pageConfig?.filters} />;
    case 'profits-table':
      return <ProfitsTableFilters currentFilters={pageFilters} filters={pageConfig?.filters} />;

    default:
      break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig, pageFilters, pageFilterType, isLoadingPageConfig]);

  useEffect(() => {
    dispatch(getReportsConfigAction());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid fluid>
      <Row className="p-b" style={{ zIndex: 2, position: 'relative' }}>
        <Col xs={12}>
          <div className="reports-filters">
            <Nav bsStyle="pills" className="tabs">
              {navRoutes.map((item) => {
                const { title, code } = item;

                return (
                  <NavItem
                    key={code}
                    active={location.pathname.includes(item.url.replace('/admin', ''))}
                    title={title}
                    onSelect={() => onSelectTab(item)}
                  >
                    <span>{item.title}</span>
                  </NavItem>
                );
              })}
            </Nav>

            {renderFilter()}
          </div>
        </Col>
      </Row>

      <Switch>
        {routes?.map((route) => (
          <Route key={route.code} exact={route.exact} path={route.to}>
            <route.component />
          </Route>
        ))}
        {routes?.length ? <Redirect to={routes?.[0]?.to} /> : null}
      </Switch>

      {isLoading ? <ReportsLoader /> : null}
    </Grid>
  );
};

export default Reports;
